/**
 * Utilitaires pour la gestion des données de démonstration
 */

// IDs et tokens de démonstration connus
const DEMO_IDS = ['00000000-0000-0000-0000-000000000001', 'demo', 'demo-id'];
const DEMO_TOKENS = ['demo', '0rpcax6y', 'demo-token'];

/**
 * Vérifie si un ID est un ID de démonstration
 * @param id - L'ID à vérifier
 * @returns true si c'est un ID de démonstration
 */
export function isDemoId(id: string | null | undefined): boolean {
  if (!id) {
    return false;
  }
  const result = DEMO_IDS.includes(id.toLowerCase());
  return result;
}

/**
 * Vérifie si un token est un token de démonstration
 * @param token - Le token à vérifier
 * @returns true si c'est un token de démonstration
 */
export function isDemoToken(token: string | null | undefined): boolean {
  if (!token) return false;
  return DEMO_TOKENS.includes(token.toLowerCase());
}

/**
 * Vérifie si on est en mode démonstration (ID ou token de démo)
 * @param id - L'ID du prospect
 * @param token - Le token du prospect
 * @returns true si on est en mode démonstration
 */
export function isDemoMode(id?: string | null, token?: string | null): boolean {
  return isDemoId(id) || isDemoToken(token);
}

/**
 * Données de démonstration pour Google Reviews
 */
export const DEMO_GOOGLE_REVIEWS = {
  name: "Démo Entreprise",
  rating: 4.6,
  reviews_count: 127,
  place_id: "demo-place-id",
  address: "123 Rue de la Démo, 1000 Lausanne",
  website: "https://demo-entreprise.fr",
  phone: "+41 21 123 45 67",
  url: "https://maps.google.com/demo",
  reviews: [
    {
      author_name: "Marie Dubois",
      rating: 5,
      text: "Service excellent, équipe très professionnelle. Je recommande vivement !",
      time: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
      profile_photo_url: ""
    },
    {
      author_name: "Jean Martin",
      rating: 4,
      text: "Très satisfait de leur travail. Résultats au-delà de mes attentes.",
      time: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString(),
      profile_photo_url: ""
    },
    {
      author_name: "Sophie Laurent",
      rating: 5,
      text: "Une équipe à l'écoute et des solutions innovantes. Parfait !",
      time: new Date(Date.now() - 21 * 24 * 60 * 60 * 1000).toISOString(),
      profile_photo_url: ""
    }
  ]
};

/**
 * Données de démonstration pour les métadonnées de prospect
 */
export const DEMO_PROSPECT_METADATA = {
  company: "Démo Entreprise",
  location: "Lausanne, Suisse",
  domain_emelia: "demo-entreprise.fr",
  industry: "Services numériques",
  companyDescription: "Une entreprise innovante spécialisée dans les solutions digitales"
};
